import React, { useRef, useState, useContext, useEffect } from 'react';
import { HubContext } from 'Redux/Context/context';
import { useLoaderData, useLocation, useNavigate} from 'react-router-dom';
import {_fetch} from 'Chore/Request';
import { VegaFlex, VegaButtonLink, VegaProgressTracker, VegaForm, VegaModal, VegaButton, VegaBox } from "@heartlandone/vega-react";
import { VegaNotify } from "@heartlandone/vega";
import StepOne from '../../Forms/ActivityForm/StepOne';
import StepTwo from '../../Forms/ActivityForm/StepTwo';
import StepThree from '../../Forms/ActivityForm/StepThree';
import StepFour from '../../Forms/ActivityForm/StepFour';
import StepFive from '../../Forms/ActivityForm/StepFive';


import { PATH } from 'Chore/Apis';

import { ROUTES_PATH } from 'Chore/Constants';
import { toggleGlobalModalAction } from 'Redux/Actions/actions';
import { formatActivityFormData, formatActivityResponseData } from 'Chore/Utils';

const { GET_ACTIVITY, POST_ACTIVITY, PUT_ACTIVITY } = PATH; 
let _completedSteps = [];
function ActivityInfoForm() {
  const params = useLoaderData();
  const location = useLocation();
  const navigate = useNavigate();
  const { formState,globalModalDispatch } = useContext(HubContext);
  const vegaForm = useRef();
  const vegaProgressTracker = useRef();
  const [currentStep, setCurrentStep] = useState(0);
  const [form, setForm] = useState(formState?.activity);
  const [isEdit, setIsEdit] = useState(false);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const _goToNextStep = (stepName) => {
    vegaForm.current.getValue().then(c => {
      setForm({ ...form, ...c});
      vegaProgressTracker.current.nextStep();
      setCurrentStep(currentStep + 1);
    });
    _completedSteps.push(stepName);
    setCompletedSteps([..._completedSteps]);
  }

  const _goToPreviousStep = stepName => {
    vegaForm.current.getValue().then(c => {
      setForm({ ...form, ...c});
      vegaProgressTracker.current.prevStep();
      setCurrentStep(currentStep - 1);
    });
    _completedSteps.pop()
    setCompletedSteps([..._completedSteps]);
  }

  const _toggleModal = (isShow = false) => {
    globalModalDispatch(toggleGlobalModalAction({isShow}));
  }

  useEffect(() => {
    if(params?.id) {
      setIsEdit(true);
    }
    _completedSteps = [];
    setCompletedSteps(_completedSteps);
  }, [params, params?.id])

  useEffect(() => {
    window.coverUrl = '';
    if(!params?.id) return;
    _toggleModal(true);
    _fetch({
      api: `${GET_ACTIVITY}/${params?.id}`
    })
    .then(res => {
      if(res.code === 2200){
        const activity = formatActivityResponseData(res?.payload)
        vegaForm.current.setValue({
          ...activity,
        }, {skipDisabled: false, skipInvisible: false});
        setForm(activity);
      }
    }).finally(() => {
      _toggleModal();
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const _submit = async () => {
    const lastPageValue = await vegaForm.current.getValue(); 
    const formData = formatActivityFormData({...form, ...lastPageValue});
    _toggleModal(true);
    _fetch({
      api: isEdit ? PUT_ACTIVITY(params?.id) : POST_ACTIVITY,
      method: isEdit ? 'PUT' : 'POST',
      data: formData,
    })
    .then(res => {
      if(res.code === 2200) {
        navigate(ROUTES_PATH.ROOT);
        window.isMultiImageInitialized = false;
        window.isAttachmentInitialized = false;
        window._documentInfo = [];
        window.imageIds = [];
        window.imageUrls = [];
        window.coverUrl = '';
      } else {
        VegaNotify.open({ type: 'error', message: 'The activity could not be published.' });
      }
    }).finally(() => {
      
      _toggleModal();
    });
  };

  const onDiscardChanges = () => {
    setIsModalOpen(false);
    navigate(-1);
  }

  return (
    <VegaFlex direction={'col'} gap={'size-16'} id="ActivityInfoForm">
      <VegaFlex className='m-b-24'>
        <VegaButtonLink
            label="Back"
            icon="fa-solid fa-angle-left"
            onVegaClick={() => {
              setIsModalOpen(true);
            }}
        />
      </VegaFlex>
      <VegaFlex className='p-x-240' direction={'col'} gap={'size-16'}>
        <VegaProgressTracker
          ref={vegaProgressTracker}
          style={{
            margin: '0 -24px 0 -24px',
            backgroundColor: 'rgb(252,252,252)',
            padding: '16px 0 16px 0',
          }}
          steps={[
            "Basic Info",
            "Date & Time",
            "Location",
            "Details",
            "Review & Publish"
          ]}
          completedSteps={completedSteps}
          direction='horizontal'
          canClickStep= {false}
        />
        <VegaForm
          data-vega-form={`form`}
          ref={vegaForm}
        >
          <StepOne currentStep={currentStep} isEdit={isEdit} form = {form} onNextClick={_goToNextStep} />
          <StepTwo currentStep={currentStep} isEdit={isEdit} form={form} onPreviousClick={_goToPreviousStep} onNextClick={_goToNextStep} />
          <StepThree currentStep={currentStep} isEdit={isEdit} form = {form} onPreviousClick={_goToPreviousStep} onNextClick={_goToNextStep} />
          <StepFour currentStep={currentStep} isEdit={isEdit} form = {form} onPreviousClick={_goToPreviousStep} onNextClick={_goToNextStep} />
          <StepFive currentStep={currentStep} isEdit={isEdit} form={form} onPreviousClick={_goToPreviousStep}  onNextClick={_submit}/>
        </VegaForm>
      </VegaFlex>
      <VegaModal
        open={isModalOpen}
        onVegaClose={() => setIsModalOpen(false)}
        modalTitle={'Leave Page'}
        size={480}
      >
        <div slot="modal-content">
          <VegaFlex direction={'col'} gap={'size-20'}>
            <VegaBox className="f-weight-500">
              Are you sure you want to leave this page?
            </VegaBox>
            <VegaBox className="f-weight-500">
              All changes will be discarded.
            </VegaBox>
          </VegaFlex>
        </div>
        <div slot="modal-footer">
          <VegaFlex direction="row" gap="size-12" justifyContent={`end`}>
            <VegaButton
              danger
              size="small"
              onVegaClick={() => setIsModalOpen(false)}
              variant="secondary"
            >
              Cancel
            </VegaButton>
            <VegaButton danger size="small" onVegaClick={onDiscardChanges}>
              Leave
            </VegaButton>
          </VegaFlex>
        </div>
      </VegaModal>
    </VegaFlex>
  );
}

export default ActivityInfoForm;
